var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"id":"input"}},[_c('Menu'),_c('transition',{attrs:{"name":"fade"}},[(_vm.groupPersistance)?_c('GroupPersistance'):_vm._e()],1),_c('p',{staticClass:"count"},[_vm._v(_vm._s(_vm.listSize)+" pers")]),_c('Form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }